import { jsxs, jsx } from 'react/jsx-runtime';
import { BubblingG, BubblingItem } from './styled.mjs';

var LoadingIcon = function LoadingIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "s" : _ref$size,
    color = _ref.color,
    overrideStyle = _ref.overrideStyle;
  return jsxs(BubblingG, {
    className: "bubblingG",
    size: size,
    color: color,
    overrideStyle: overrideStyle,
    children: [jsx(BubblingItem, {}), jsx(BubblingItem, {}), jsx(BubblingItem, {})]
  });
};

export { LoadingIcon as default };
